import { Link, useLocation, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet-async';
import { Col, Row } from 'react-bootstrap';

const DonateScreen = () => {
  return (
    <Container className="small-container">
      <Helmet>
        <title>Donate</title>
      </Helmet>
      <h1 className="my-3">Donate</h1>
      <p>
        Your donations are always welcome. With your donations, we can help a lot of people.  You can donate cash to help buy food and groceries.  It can help students buy their school supplies for pay for their education

      If you would like to donate please email us below:
      </p>
      {/* <p><i className="fa fa-phone" />&nbsp;1800-16516453 (PLDT)</p>
      <p><i className="fa fa-phone" />&nbsp;1800-86516453 (GLOBE)</p> */}
      <p><i className="fa fa-envelope" />&nbsp;projectdream@code200.dev</p>
      <p>You can also donate below through GCASH</p>
      <Row className="text-mute">
        <Col md={2}><img src="/images/logo/gcash.png" className="img-rounded img-thumbnail" /></Col>
        <Col md={6}>
          #0960-100-6276 Amparo L.
          <br />
          #0995-862-2329 Sayra O.
        </Col>
      </Row>

    </Container>
  );
}

export default DonateScreen;
